export default {
  title: 'Dostosuj zamówienie',
  product_info: {
    earn_points: 'Zdobądź {{points}} punktów',
  },
};
